var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4"},[_c('v-tabs',{attrs:{"active-class":!_vm.$vuetify.theme.dark ? 'secondary-bg' : 'white'},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{staticClass:"text-capitalize",attrs:{"disabled":_vm.loading,"to":{
				name: 'task-papers'
			}}},[_vm._v(" Tasks ")]),_c('v-tab',{staticClass:"text-capitalize",attrs:{"disabled":_vm.loading,"to":{
				name: 'task-matching'
			}}},[_vm._v(" Validate ")])],1),_c('v-divider'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }